import React, { useState } from "react";
import "./NavbarStyles.css";
// import { Link } from "react-router-dom";
import { Link, animateScroll as scroll } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => {
    setClick(!click);
  };
  const closeMobileMenu = () => {
    setClick(false); // Function to close the mobile menu
  };

  // color change of nav bar while scrolling

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 100) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);

  //handleResumeDownload
  const handleResume = () => {
    const resumeFilename = "Shashikant-Yadav-Resume.pdf"; // Make sure this matches the filename in the public folder
    const resumeURL =
      process.env.PUBLIC_URL + "/Resume/" + "Shashikant-Yadav-Resume.pdf";
    const link = document.createElement("a");
    link.href = resumeURL;
    link.download = resumeFilename;
    link.click();
    window.open(
      "https://drive.google.com/file/d/1IK_RuO422W3LBKClLBlmaQZ68OWD7Ooo/view",
      "_blank"
    );
  };

  const [isHovered, setIsHovered] = useState(false);
  const linkStyles = {
    cursor: "pointer",
    backgroundColor: isHovered ? "#222" : "rgb(248, 217, 15)",
    padding: "7px",
    border: "1px solid rgb(248, 217, 15)",
    borderRadius: "2px",
    color: isHovered ? "white" : "black",
  };


  const navaa={
    cursor: "pointer",
  }
  return (
    

<div className={color ? "Header Header-bg" : "Header"} >
      <Link 
      activeClass={"active"}
      spy={true}
      to="home"
      smooth={true}
      offset={-100}
      delay={0}
      duration={0}
      style={navaa}
      onClick={closeMobileMenu}
      >
        <h1>Shashikant Yadav</h1>
      </Link>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="home"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            Home</Link>
        </li>
        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="about"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            About</Link>
        </li>
        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="skills"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            Skills</Link>
        </li>
        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="stats"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            My Stats</Link>
        </li>
        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="projects"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            Projects</Link>
        </li>

        <li>
          <Link 
          activeClass={"active"}
          spy={true}
          to="contact"
          smooth={true}
          offset={-100}
          delay={0}
          duration={0}
          style={navaa}
          onClick={closeMobileMenu}
          >
            Contact</Link>
        </li>

        <li>
          <a
            onClick={handleResume}
            style={linkStyles}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            Resume
          </a>
        </li>
      </ul>

      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes
            size={20}
            style={{
              color: "white",
            }}
          />
        ) : (
          <FaBars
            size={20}
            style={{
              color: "white",
            }}
          />
        )}
      </div>
    </div>

// <div className={color ? "Header Header-bg" : "Header"}>
    //   <Link to={"/"}>
    //     <h1>Shashikant Yadav</h1>
    //   </Link>
    //   <ul className={click ? "nav-menu active" : "nav-menu"}>
    //     <li>
    //       <Link to={"/"}>Home</Link>
    //     </li>
    //     <li>
    //       <Link to={"/about"}>About</Link>
    //     </li>
    //     <li>
    //       <Link to={"/skills"}>Skills</Link>
    //     </li>
    //     <li>
    //       <Link to={"/myStats"}>My Stats</Link>
    //     </li>
    //     <li>
    //       <Link to={"/project"}>Projects</Link>
    //     </li>

    //     <li>
    //       <Link to={"/contact"}>Contact</Link>
    //     </li>

    //     <li>
    //       <a
    //         onClick={handleResume}
    //         style={linkStyles}
    //         onMouseEnter={() => setIsHovered(true)}
    //         onMouseLeave={() => setIsHovered(false)}
    //       >
    //         Resume
    //       </a>
    //     </li>
    //   </ul>

    //   <div className="hamburger" onClick={handleClick}>
    //     {click ? (
    //       <FaTimes
    //         size={20}
    //         style={{
    //           color: "white",
    //         }}
    //       />
    //     ) : (
    //       <FaBars
    //         size={20}
    //         style={{
    //           color: "white",
    //         }}
    //       />
    //     )}
    //   </div>
    // </div>

  );
};

export default Navbar;
